/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get */
// Extends from
import AssessmentController from './assessment';
// Ember imports
import { action, computed } from '@ember/object';
import { isEmpty } from '@ember/utils';

export default class UnlinkedPostsController extends AssessmentController {
  @computed(
    'model.posts.@each.assessment_id',
    'model.page.{hasAssessments,assessment_ids.[]}',
  )
  get unlinkedPosts() {
    let hasAssessments = this.model.page.hasAssessments;
    let pageAssessments = this.model.page.assessment_ids;
    if (hasAssessments) {
      // If page has assessments enabled, filter out included assessments' posts,
      // as they would appear in their own tabs
      // There could be multiple assessments enabled/disabled
      return this.model.posts.filter((post) => {
        return (
          !pageAssessments.includes(post.get('assessment_id')) ||
          isEmpty(post.get('assessment_id'))
        );
      });
    }
    // By default, return all
    return this.model.posts;
  }

  @action
  refresh() {
    this.get('model.posts').update();
  }
}
